import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { fmtDuree, fmtNum, fmtPct, TONE_TEXT, trsTone } from "@/lib/format";
import { Panel } from "@/components/common/Panel";
import { DataTable } from "@/components/common/DataTable";
import { LoadingState, ErrorState } from "@/components/common/States";
import { cn } from "@/lib/utils";

const QUART_STATUT = { termine: "Terminé", en_cours: "En cours", a_venir: "À venir", futur: "À venir" };

const pct = (k) => ({ key: k, header: k === "trs" ? "TRS" : k[0].toUpperCase(), align: "right", render: (r) => <span className={cn(TONE_TEXT[trsTone(r[k])])}>{fmtPct(r[k])}</span> });

const columns = [
  { key: "quart", header: "Quart", render: (r) => <span className="font-semibold">{r.quart}</span> },
  { key: "horaires", header: "Horaires", mono: true, cellClassName: "text-muted-foreground" },
  { key: "statut_quart", header: "État", render: (r) => <span className="text-muted-foreground">{QUART_STATUT[r.statut_quart] || r.statut_quart || "—"}</span> },
  pct("trs"), pct("disponibilite"), pct("performance"), pct("qualite"),
  { key: "bonnes", header: "Bonnes", align: "right", render: (r) => fmtNum(r.bonnes) },
  { key: "rejets", header: "Rejets", align: "right", render: (r) => fmtNum(r.rejets) },
  { key: "objectif", header: "Objectif", align: "right", render: (r) => (r.objectif ? `${fmtNum(r.bonnes)} / ${fmtNum(r.objectif)}` : "—") },
  { key: "temps_arret_sec", header: "Arrêts", align: "right", render: (r) => fmtDuree(r.temps_arret_sec) },
];

export const ParQuartPanel = ({ lignes, ligneId, onLigneChange }) => {
  const { data, isLoading, error, refetch } = useQuery({ queryKey: ["trs-par-quart", ligneId], queryFn: () => get("/trs/par-quart", { ligne_id: ligneId }), enabled: !!ligneId });
  return (
    <Panel title="Répartition par quart" subtitle={data?.date} testId="par-quart-panel"
      actions={<select data-testid="par-quart-ligne-select" value={ligneId || ""} onChange={(e) => onLigneChange(Number(e.target.value))} className="h-6 bg-input border border-border rounded-sm text-[11px] px-1.5">
        {lignes.map((l) => <option key={l.ligne_id} value={l.ligne_id}>{l.ligne}</option>)}
      </select>}>
      {!ligneId ? <div className="p-4 text-xs text-muted-foreground">Aucune ligne active.</div>
        : isLoading ? <LoadingState rows={3} /> : error ? <ErrorState error={error} onRetry={refetch} />
        : <DataTable testId="par-quart-table" columns={columns} rows={data?.par_quart || []} rowKey={(r) => r.quart_id} emptyTitle="Aucun quart configuré" />}
      {data?.jour && <div className="px-3 py-1.5 border-t border-border/60 text-[11px] font-mono text-muted-foreground flex gap-4">
        <span>Journée : <b className={cn(TONE_TEXT[trsTone(data.jour.trs)])}>{fmtPct(data.jour.trs)}</b></span>
        <span>D {fmtPct(data.jour.disponibilite)}</span><span>P {fmtPct(data.jour.performance)}</span><span>Q {fmtPct(data.jour.qualite)}</span>
      </div>}
    </Panel>
  );
};
